import { connect } from 'react-redux'
import compose from 'lodash/flowRight'

import { RigipsStore } from 'redux/redux'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import withPositionQuery from './positionQuery'
import withChangePositionAmountMutation from './changePositionAmountMutation'
import withChangePositionClippingMutation from './changePositionClippingMutation'
import withDeletePositionMutation from './deletePositionMutation'
import withCustomizeElementMutation from './customizeElementMutation'
import withChangePositionVATMutation from './changePositionVATMutation'
import withChangePositionHourlyRateMutation from './changePositionHourlyRateMutation'
import withChangePositionFilterMutation from './changePositionFilterMutation'

import CalculationOverviewPage from './calculationOverviewPage'

const mapStateToProps = (state: RigipsStore) => {
  const { auth, calcProject } = state

  return { auth, calcProject }
}

const withConnect = connect(mapStateToProps)

export default compose(
  withConnect,
  withPositionQuery,
  withDeletePositionMutation,
  withCustomizeElementMutation,
  withChangePositionVATMutation,
  withChangePositionAmountMutation,
  withChangePositionFilterMutation,
  withChangePositionClippingMutation,
  withChangePositionHourlyRateMutation,
  withTranslation(),
  withRouter,
)(CalculationOverviewPage)
